import { useState, useEffect, useRef } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import { Button } from '@wajeez-web/components/ui';
import { PlusIcon } from '@heroicons/react/solid';
import { SuperAdminSystemPermissions } from '@wajeez-web/core/types';
import { useNavigate } from 'react-router-dom';
import {
  useContentSelector,
  ComponentTypesActions,
} from '@wajeez-web/stores/content';
import { HandleTableData } from '@wajeez-web/components/data-table';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { DotsHorizontalIcon } from '@heroicons/react/outline';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { DataTable, Dropdown, CheckBoxType } from '@wajeez-web/components/mui';

const ComponentTypesPage = () => {
  const navigate = useNavigate();

  const {
    tablePreferances,
    setTablePreferences,
    getData: getDatatableData,
    isTableReferencesLoading,
  } = HandleTableData(
    'componentTypess',
    ComponentTypesActions.getComponentTypesDatatableAsync,
    undefined,
    undefined,
    [{ property: 1, orderByDirection: 1 }]
  );

  const dataTableData = useContentSelector(
    ({ componentTypes }) => componentTypes.componentTypesDatatable
  );

  const { t } = useTranslation();

  return (
    <>
      <PageLayoutsContainer
        title={`Component Types`}
        endSideComponent={[
          {
            element: (
              <Button
                title={'Add Component Type'}
                Icon={PlusIcon}
                onClick={() => {
                  navigate('/component-types/new');
                }}
                bg="primary"
                color="white"
              />
            ),
            permission: [SuperAdminSystemPermissions.components.add],
          },
        ]}
        breadCrumbsLinks={[{ title: '' }]}
      >
        <DataTable
          dataTableData={dataTableData.data as contentEntityDataType}
          onHeaderManage={(header) => {
            const flags = header
              ?.filter((h) => h.selected)
              .reduce(
                (previousValue: number, currentValue: CheckBoxType) =>
                  previousValue + Number(currentValue.value),
                0
              );

            tablePreferances &&
              flags &&
              setTablePreferences({
                ...tablePreferances,
                flags: flags + 1,
              });
          }}
          onPaginationChange={(pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                pageSize: pagination.pageSize,
              });
          }}
          sort={tablePreferances?.sortingOperations?.[0]}
          onSort={(sort) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                sortingOperations: [sort],
              });
          }}
          onFilter={(filters, pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                filteringOperations: filters.map((f) => {
                  return {
                    property: Number(f.key),
                    cretiria: f.value,
                    comparisonType: f.operator,
                  };
                }),
              });
          }}
          isLoading={dataTableData.status === 'loading'}
          renderRowActions={(row) => {
            return (
              <div className="w-full flex justify-center items-center">
                <Dropdown
                  id={`action-${row[1]}`}
                  items={[
                    {
                      label: 'Content',
                      onClick: () => {
                        navigate(`/component-types/${row[1]}`);
                      },
                    },
                    {
                      label: 'Edit',
                      onClick: () => {
                        navigate(`/component-types/${row[1]}/edit`);
                      },
                    },
                    {
                      label: 'Create Component',
                      onClick: () => {
                        navigate(`/components/new?componentTypeId=${row[1]}`);
                      },
                    },
                    {
                      label: 'Clone',
                      onClick: () => {
                        navigate(`/component-types/${row[1]}/new`);
                      },
                    },
                  ]}
                  label={
                    <div style={{ color: '#343a40' }}>
                      <DotsHorizontalIcon
                        style={{ width: '28px', height: '24px' }}
                      />
                    </div>
                  }
                  buttonStyle={{
                    width: '34px',
                    minWidth: '34px',
                    paddingRight: '2px',
                    paddingLeft: '2px',
                    color: 'black',
                  }}
                />
              </div>
            );
          }}
        />
      </PageLayoutsContainer>
    </>
  );
};

export default ComponentTypesPage;
